import "./rules.less";

const Rules = () => {
  return (
    <div className="page-container rules-container">
      <h1>Reglamento Interclubes Buenos Aires</h1>

      <h3 className="chapter-title">CAPÍTULO I – OBJETO</h3>

      <h4 className="rules-title">Artículo 1 – Objeto del Torneo</h4>
      <p>
        El presente Reglamento tiene por objeto regular la organización y desarrollo del Torneo Interclubes de Squash,
        competencia destinada exclusivamente a clubes sociales y deportivos constituidos como asociaciones civiles sin fines de lucro.
      </p>
      <p>El Torneo tiene como finalidad:</p>
      <ul>
        <li>Fomentar la práctica del squash en el ámbito institucional de los clubes sociales.</li>
        <li>Promover la competencia deportiva en un marco de respeto, caballerosidad y espíritu deportivo.</li>
        <li>Fortalecer la integración y el vínculo entre las instituciones participantes.</li>
        <li>Garantizar igualdad de condiciones competitivas entre los equipos.</li>
        <li>
          Preservar y promover el tradicional "Tercer Tiempo", entendido como espacio de encuentro social
          posterior a la competencia, elemento esencial del espíritu del Interclubes.
        </li>
      </ul>
      <p>
        El Interclubes constituye una competencia entre instituciones, y no entre complejos comerciales ni jugadores individuales,
        sustentada tanto en la excelencia deportiva como en la convivencia social entre clubes.
      </p>

      <h3 className="chapter-title">CAPÍTULO II – AUTORIDADES</h3>

      <h4 className="rules-title">Artículo 2 – Estructura organizativa</h4>
      <p>La organización y administración del Torneo Interclubes estará a cargo de:</p>
      <ul>
        <li>Los Clubes participantes.</li>
        <li>La Reunión de Capitanes Generales.</li>
        <li>Los capitanes de cada equipo.</li>
        <li>El Comité del Interclubes.</li>
      </ul>

      <h4 className="rules-title">Artículo 3 – Clubes Participantes</h4>
      <p>Cada club será responsable de:</p>
      <ul>
        <li>La inscripción y conformación de sus equipos.</li>
        <li>El cumplimiento del presente Reglamento.</li>
        <li>La conducta deportiva y disciplinaria de sus jugadores, capitanes y representantes.</li>
        <li>La organización del encuentro cuando actúe como local, incluyendo el Tercer Tiempo.</li>
      </ul>

      <h4 className="rules-title">Artículo 4 – Reunión de Capitanes Generales</h4>
      <ul>
        <li>Estará integrada por un (1) Capitán General o representante designado por cada club participante.</li>
        <li>Constituye el ámbito de coordinación general del Torneo.</li>
        <li>
          Tendrá las siguientes facultades:
          <ul>
            <li>Aprobar o modificar el presente Reglamento.</li>
            <li>Definir el calendario de competencia.</li>
            <li>
              Determinar la modalidad y el tipo de torneo a disputarse en cada temporada
              (formato, categorías, sistema de juego, instancias finales, ascensos y descensos, etc.).
            </li>
            <li>Tratar cuestiones organizativas generales vinculadas al desarrollo del Interclubes.</li>
            <li>Aceptar la inclusión de nuevos clubes o equipos.</li>
          </ul>
        </li>
        <li>Las decisiones se adoptarán por mayoría simple.</li>
        <li>
          A efectos de la votación, cada club contará con tantos votos como equipos efectivamente inscriptos
          y participantes tenga en la temporada correspondiente.
        </li>
        <li>
          El número de votos de cada club será determinado al inicio de cada temporada conforme a la cantidad
          de equipos oficialmente inscriptos.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 5 – Capitanes de equipo</h4>
      <ul>
        <li>
          Tienen la responsabilidad de la organización del evento del día. Se ocuparán de la disponibilidad de canchas,
          vestuarios, toallas, tercer tiempo, formación del equipo y deberán interceder de producirse cualquier
          inconveniente durante el transcurso de los partidos.
        </li>
        <li>
          En el caso de producirse algún conflicto con el equipo y/o jugadores de otro club, deberán procurar
          solucionarlo junto al capitán y/o sub capitán del otro equipo.
        </li>
        <li>
          De no llegar a un acuerdo, deberán enviar un chat únicamente a algún integrante del GRUPO de CAPITANES
          de CLUBES explicando el caso.
        </li>
        <li>
          <b>Conformación de equipos de cada fecha:</b> Se deberá confirmar el equipo en PRÓXIMA FECHA en la web
          antes de las 18 hs del jueves.
        </li>
        <li>
          <b>Resultado:</b> Una vez concluidos los 5 partidos de la fecha, se deberán cargar en la web como RESULTADO,
          acordando los parciales de cada partido. Es importante que esto se haga de la manera más exacta ya que son
          valores que determinan la ubicación en la tabla. En caso de que el capitán no asista a esa fecha, se deberá
          designar a algún jugador que se encargue de cargar el resultado de la fecha. El capitán local carga el
          resultado y el capitán visitante confirma que los resultados sean los correctos. En caso de que el local
          no lo cargue, se le pide al visitante lo haga.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 6 – Comité del Interclubes</h4>
      <ul>
        <li>
          El Comité estará integrado por cinco (5) miembros designados por los clubes participantes al inicio de cada temporada.
        </li>
        <li>
          Será el órgano encargado de mediar y resolver los conflictos que no puedan ser solucionados entre los
          capitanes de los equipos involucrados.
        </li>
        <li>Intervendrá a pedido formal de alguno de los clubes afectados.</li>
        <li>Sus decisiones deberán ser fundadas y serán de cumplimiento obligatorio.</li>
        <li>Las resoluciones se adoptarán por mayoría simple de sus miembros.</li>
      </ul>

      <h3 className="chapter-title">CAPÍTULO III – PARTICIPACIÓN</h3>

      <h4 className="rules-title">Artículo 7 – Entidades habilitadas</h4>
      <p>
        Podrán participar del Torneo Interclubes exclusivamente clubes sociales y deportivos constituidos como
        asociaciones civiles sin fines de lucro.
      </p>
      <p>A los efectos del presente Reglamento, se entiende por club social aquella institución que:</p>
      <ul>
        <li>Posea personería jurídica vigente.</li>
        <li>Cuente con padrón de socios activos.</li>
        <li>
          No tenga como actividad principal o accesoria la explotación comercial de canchas deportivas mediante
          alquiler al público en general.
        </li>
        <li>
          No incorpore jugadores bajo modalidad de "socio transitorio" o figura equivalente cuyo único objeto
          sea la participación en el Torneo.
        </li>
      </ul>
      <p>
        Quedan expresamente excluidos los complejos deportivos comerciales, centros de entrenamiento privados
        y cualquier entidad cuya actividad principal sea el alquiler de canchas.
      </p>
      <p>El Comité podrá requerir documentación respaldatoria a fin de verificar el cumplimiento de estos requisitos.</p>

      <h4 className="rules-title">Artículo 8 – Inscripción de equipos</h4>
      <ul>
        <li>
          Cada club podrá inscribir la cantidad de equipos que considere pertinente, respetando el límite de dos
          equipos por cancha y cumpliendo con los requisitos establecidos en el presente Reglamento.
        </li>
        <li>La inscripción deberá realizarse dentro del plazo fijado para cada temporada.</li>
        <li>
          Se considerará oficialmente inscripto un equipo una vez presentada su correspondiente Lista de Buena Fe
          en tiempo y forma.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 9 – Jugadores habilitados</h4>
      <ul>
        <li>Sólo podrán participar aquellos jugadores que sean socios activos y con cuota al día de la institución que representen.</li>
        <li>
          Los jugadores socios de dos o más clubes podrán integrar la Lista de Buena Fe de una sola institución
          por temporada, debiendo optar por una antes del cierre de listas.
        </li>
        <li>
          No se permitirá la incorporación de jugadores bajo modalidad de socio transitorio o cualquier figura
          equivalente destinada exclusivamente a participar del Interclubes.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 10 – Lista de Buena Fe (LBF)</h4>
      <ul>
        <li>Cada equipo deberá presentar una Lista de Buena Fe con un mínimo de ocho (8) jugadores.</li>
        <li>
          Los jugadores deberán estar ordenados en ranking descendente de nivel competitivo, ocupando el puesto N° 1
          el jugador de mayor nivel y así sucesivamente. El orden declarado deberá reflejar el nivel real y actual
          del jugador al momento de su presentación.
        </li>
        <li>
          La LBF deberá incluir:
          <ul>
            <li>Capitán.</li>
            <li>Subcapitán o segundo responsable.</li>
            <li>Teléfonos de contacto actualizados.</li>
          </ul>
        </li>
        <li>
          La LBF deberá enviarse al grupo oficial de Capitanes de la categoría, en formato Excel y utilizando la
          planilla modelo oficial, consignando apellido y nombre completos (sin apodos ni seudónimos).
        </li>
        <li>
          La LBF deberá ser enviada con una anticipación mínima de siete (7) días corridos a la fecha establecida
          como inicio del Torneo.
        </li>
        <li>
          Una vez presentada, el orden declarado será vinculante para el presente torneo, salvo autorización expresa del Comité.
        </li>
        <li>La LBF deberá encontrarse exhibida en un lugar visible en las instalaciones del club.</li>
      </ul>

      <h4 className="rules-title">Artículo 11 – Conformación de equipos, bloques y régimen de suplencias</h4>
      <p>La Lista de Buena Fe (LBF) general del club determinará el orden de mérito absoluto de sus jugadores.</p>
      <p>
        A los efectos de la competencia, los jugadores quedarán organizados en bloques de cinco (5) posiciones,
        conforme la cantidad de equipos inscriptos por el club.
      </p>

      <p><b>1. Bloques estructurales</b></p>
      <ul>
        <li>Posiciones 1 a 5: Equipo A</li>
        <li>Posiciones 6 a 10: Equipo B</li>
        <li>Posiciones 11 a 15: Equipo C</li>
        <li>Posiciones 16 a 20: Equipo D</li>
      </ul>
      <p>Cada bloque será considerado estructural para determinar la categoría natural del jugador.</p>

      <p><b>2. Régimen de ascenso</b></p>
      <ul>
        <li>
          Los jugadores podrán disputar encuentros en equipos de categoría superior a la de su bloque de origen,
          respetando el límite máximo de posiciones establecido en el presente artículo.
        </li>
        <li>No se permitirá que un jugador compita en una categoría inferior a la correspondiente a su bloque.</li>
        <li>No se permitirá que un jugador actúe en dos equipos en la misma fecha.</li>
      </ul>

      <p><b>3. Límite máximo de suplentes (Regla +15)</b></p>
      <p>A fin de preservar el equilibrio competitivo, se establece un límite máximo de posiciones habilitadas para suplencias en cada categoría:</p>
      <ul>
        <li>
          En el Equipo de Primera (posiciones 1 a 5), podrán utilizarse como suplentes jugadores ubicados hasta
          la posición número 20 inclusive de la LBF general del club.
        </li>
        <li>
          En el Equipo de Segunda (posiciones 6 a 10), podrán utilizarse como suplentes jugadores ubicados hasta
          la posición número 25 inclusive de la LBF general del club.
        </li>
        <li>En el Equipo de Tercera (posiciones 11 a 15), no habrá límite máximo de posiciones para suplencias.</li>
        <li>En el Equipo de Cuarta no habrá límite máximo de posiciones para suplencias.</li>
      </ul>
      <p>En todos los casos deberá respetarse la prohibición de descenso establecida en el presente Reglamento.</p>

      <p><b>4. Conformación semanal</b></p>
      <p>En cada fecha, los equipos deberán conformarse respetando:</p>
      <ul>
        <li>El orden general de mérito declarado en la LBF.</li>
        <li>Los bloques estructurales.</li>
        <li>El régimen de ascenso permitido.</li>
        <li>El límite máximo de suplencias (+15).</li>
      </ul>
      <p><b>Ejemplo válido:</b></p>
      <ul>
        <li>Equipo de Primera: 1, 2, 3, 13 y 14.</li>
        <li>Equipo de Segunda: 6, 7, 8, 9 y 10.</li>
      </ul>

      <p><b>5. Sanción</b></p>
      <p>
        El incumplimiento del presente artículo implica la pérdida automática de los puntos obtenidos en la posición
        irregular, sin perjuicio de otras sanciones que pueda disponer el Comité.
      </p>

      <p><b>6. Equipos en la misma Categoría</b></p>
      <p>
        En caso de que, por aplicación del régimen de ascensos y descensos, un club cuente con más de un equipo en
        una misma categoría, dichos equipos deberán competir en forma independiente durante toda la temporada.
      </p>
      <ul>
        <li>Cada equipo deberá contar con su propia Lista de Buena Fe, claramente diferenciada desde el inicio del torneo.</li>
        <li>
          Los jugadores inscriptos en la Lista de Buena Fe de uno de esos equipos serán considerados exclusivos
          de ese equipo y no podrán integrar ni disputar encuentros para el otro equipo del mismo club en la misma categoría.
        </li>
        <li>La exclusividad regirá durante todo el campeonato vigente.</li>
      </ul>

      <h3 className="chapter-title">CAPÍTULO IV – SISTEMA DE COMPETENCIA</h3>

      <h4 className="rules-title">Artículo 12 – Categorías</h4>
      <p>
        El Torneo Interclubes contará con hasta cuatro (4) categorías: Primera, Segunda, Tercera y Cuarta.
        Cada categoría contará con la cantidad que asegure la formación de la misma con 8 equipos.
        La última categoría tendrá un máximo de 13, en caso de ser 14 o más se conformará una categoría más.
      </p>

      <h4 className="rules-title">Artículo 13 – Estructura anual y calendario</h4>
      <p>
        La modalidad, formato y sistema de competencia de cada temporada serán definidos por la Reunión de
        Capitanes Generales y formalizados mediante un Apéndice Anual.
      </p>
      <p>El Interclubes se desarrollará en dos (2) torneos anuales:</p>
      <ul>
        <li>Torneo Apertura, correspondiente al primer semestre del año.</li>
        <li>Torneo Clausura, correspondiente al segundo semestre del año.</li>
      </ul>
      <p>Ambos torneos serán independientes entre sí, salvo disposición expresa adoptada por la Reunión de Capitanes Generales.</p>
      <p>El calendario oficial de competencia será aprobado antes del inicio de cada torneo e incluirá:</p>
      <ul>
        <li>Fecha de inicio y finalización.</li>
        <li>Fechas de disputa de cada jornada.</li>
        <li>Eventuales fechas de recuperación.</li>
        <li>Instancias finales, si correspondieran.</li>
      </ul>
      <p>Las fechas deberán respetarse salvo acuerdo entre los clubes involucrados o resolución del Comité.</p>

      <h4 className="rules-title">Artículo 14 – Conformación de los encuentros</h4>
      <ul>
        <li>Cada fecha se disputará entre dos clubes, actuando uno como local y el otro como visitante.</li>
        <li>En cada categoría, cada club presentará cinco (5) jugadores, disputándose cinco (5) partidos individuales por encuentro.</li>
        <li>
          Todos los partidos programados deberán disputarse, independientemente de que el resultado general del
          encuentro ya se encuentre definido.
        </li>
        <li>Se establece las 20hs como hora límite para empezar los partidos de la fecha.</li>
        <li>Si a las 20hs no ha llegado al club ningún jugador de uno de los equipos, se considerará W.O.</li>
        <li>Se recomienda comenzar el primer partido a las 19 hs. para que el tercer tiempo sea más prolongado.</li>
      </ul>

      <h4 className="rules-title">Artículo 15 – Resultado del encuentro</h4>
      <p>El equipo que obtenga mayor cantidad de partidos individuales ganados será considerado vencedor de la fecha.</p>
      <p>Los resultados posibles del encuentro serán:</p>
      <ul>
        <li>3 a 2</li>
        <li>4 a 1</li>
        <li>5 a 0</li>
      </ul>

      <h4 className="rules-title">Artículo 16 – Sistema de puntuación</h4>
      <p>El sistema de puntuación será el siguiente:</p>
      <ul>
        <li>Cada partido individual ganado otorgará un (1) punto en la tabla general.</li>
        <li>El equipo que resulte ganador del encuentro obtendrá dos (2) puntos adicionales.</li>
      </ul>
      <p><b>Ejemplos:</b></p>
      <ul>
        <li>Resultado 3-2: El ganador suma 5 puntos (3 + 2) y el perdedor suma 2 puntos.</li>
        <li>Resultado 4-1: El ganador suma 6 puntos (4 + 2) y el perdedor suma 1 punto.</li>
        <li>Resultado 5-0: El ganador suma 7 puntos (5 + 2) y el perdedor suma 0 puntos.</li>
      </ul>

      <h4 className="rules-title">Artículo 17 – Tabla de posiciones y desempates</h4>
      <p>
        La tabla de cada categoría se conformará mediante la sumatoria de los puntos obtenidos en cada fecha
        conforme al sistema establecido en el artículo anterior.
      </p>
      <p>En caso de igualdad de puntos en la tabla final, se aplicarán los siguientes criterios, en el orden indicado:</p>
      <ol>
        <li>Cantidad de Fechas ganadas</li>
        <li>Mayor cantidad de partidos individuales ganados.</li>
        <li>Mayor diferencia entre partidos individuales ganados y perdidos.</li>
        <li>Resultado del encuentro disputado entre los equipos involucrados.</li>
        <li>Mayor diferencia de games.</li>
        <li>Sorteo.</li>
      </ol>

      <h4 className="rules-title">Artículo 18 – Ascensos y Descensos</h4>
      <p>
        El Torneo Interclubes contará con un régimen de ascensos y descensos entre categorías, a fin de preservar
        el equilibrio competitivo y la movilidad deportiva.
      </p>
      <p>
        La modalidad específica de ascensos, descensos y eventuales repechajes será determinada anualmente por la
        Reunión de Capitanes Generales y formalizada en el Apéndice correspondiente a cada temporada.
      </p>

      <h4 className="rules-title">Artículo 19 – Principios mínimos</h4>
      <p>El régimen anual deberá respetar los siguientes principios:</p>
      <ul>
        <li>
          Deberá establecerse al menos un (1) ascenso por categoría, salvo decisión fundada adoptada por la
          Reunión de Capitanes Generales.
        </li>
        <li>No podrá modificarse el régimen de ascensos y descensos una vez iniciado el torneo correspondiente.</li>
        <li>
          El sistema deberá ser aprobado antes del inicio de cada torneo y comunicado oficialmente a todos los clubes participantes.
        </li>
        <li>
          En caso de establecerse repechajes, deberán definirse previamente su modalidad, plazos y criterios deportivos.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 20 – Determinación final</h4>
      <p>
        Los ascensos y descensos se definirán conforme al sistema establecido en el Apéndice anual, el cual formará
        parte integrante del presente Reglamento.
      </p>

      <h3 className="chapter-title">CAPÍTULO VI – RÉGIMEN DISCIPLINARIO</h3>

      <h4 className="rules-title">Artículo 21 – Principios generales</h4>
      <p>
        Todos los clubes, capitanes y jugadores deberán actuar conforme a los principios de buena fe, respeto,
        espíritu deportivo y lealtad institucional.
      </p>
      <p>Las conductas que vulneren el presente Reglamento o el espíritu del Interclubes podrán ser sancionadas por el Comité.</p>

      <h4 className="rules-title">Artículo 22 – Responsabilidad institucional</h4>
      <p>
        Cada club será responsable por la conducta de sus jugadores, capitanes y representantes, tanto dentro como
        fuera de la cancha, incluyendo el desarrollo del Tercer Tiempo.
      </p>

      <h4 className="rules-title">Artículo 23 – Árbitro</h4>
      <p>
        Se recomienda que en cada encuentro interclubes haya un jugador designado que oficie como árbitro del partido.
        El árbitro deberá actuar con imparcialidad y conforme a las Reglas Oficiales de la World Squash Federation (WSF) vigentes.
      </p>
      <p>
        En caso de designarse árbitro, sus decisiones durante el desarrollo del partido serán inapelables en lo deportivo,
        sin perjuicio de los reclamos formales que pudieran efectuarse posteriormente ante el Comité Resolutivo por
        cuestiones reglamentarias o disciplinarias.
      </p>

      <h4 className="rules-title">Artículo 24 – Infracciones deportivas</h4>
      <p>Se considerarán infracciones, entre otras:</p>
      <ul>
        <li>La inclusión indebida de jugadores.</li>
        <li>El incumplimiento del orden establecido en la Lista de Buena Fe.</li>
        <li>La violación del régimen de bloques y suplencias.</li>
        <li>La no presentación de jugadores o del equipo completo.</li>
        <li>La adulteración de resultados o información oficial.</li>
      </ul>

      <h4 className="rules-title">Artículo 25 – Incomparecencia</h4>
      <p>
        Cada club deberá presentar cinco (5) jugadores por categoría, en condiciones reglamentarias y físicamente
        aptos para disputar el encuentro.
      </p>
      <ul>
        <li>Si un equipo no se presentara a disputar una fecha sin causa justificada, perderá el encuentro por 5-0.</li>
        <li>No se considerará válida la presentación de jugadores que no se encuentren en condiciones reales de disputar el partido.</li>
      </ul>

      <p><b>Régimen de inicio del quinto partido</b></p>
      <ul>
        <li>
          Una vez finalizado el cuarto (4°) partido del encuentro, el quinto (5°) partido deberá iniciarse dentro
          de los treinta (30) minutos siguientes.
        </li>
        <li>
          Si transcurrido dicho plazo uno de los jugadores no se encontrara presente y en condiciones de comenzar
          el partido, se considerará incomparecencia (walkover) en esa posición.
        </li>
        <li>
          Si dicha situación determinara que el equipo no complete los cinco (5) partidos reglamentarios, el
          encuentro podrá declararse perdido por 5-0.
        </li>
        <li>
          Lo dispuesto precedentemente no será de aplicación cuando, de común acuerdo entre los capitanes de los
          clubes involucrados, se haya decidido esperar o se hubieran establecido horarios especiales previamente convenidos.
        </li>
        <li>El Comité podrá evaluar circunstancias excepcionales debidamente acreditadas.</li>
      </ul>

      <h4 className="rules-title">Artículo 26 – Conductas antideportivas</h4>
      <p>Podrán ser sancionadas las conductas que impliquen:</p>
      <ul>
        <li>Falta de respeto hacia rivales, árbitros o autoridades.</li>
        <li>Comportamientos contrarios al espíritu deportivo.</li>
        <li>
          Incumplimiento de obligaciones como club local, incluyendo la organización adecuada del encuentro y del Tercer Tiempo.
        </li>
      </ul>

      <h4 className="rules-title">Artículo 27 – Sanciones</h4>
      <p>El Comité podrá aplicar, según la gravedad del caso:</p>
      <ul>
        <li>Apercibimiento.</li>
        <li>Pérdida de puntos.</li>
        <li>Pérdida del encuentro.</li>
        <li>Suspensión del jugador o del equipo.</li>
        <li>Cualquier otra medida razonable que preserve el orden y el espíritu del Torneo.</li>
      </ul>

      <h4 className="rules-title">Artículo 28 – Procedimiento</h4>
      <ul>
        <li>Las situaciones conflictivas deberán ser resueltas en primera instancia entre los capitanes involucrados.</li>
        <li>En caso de no llegar a un acuerdo, cualquiera de los clubes podrá elevar el caso al Comité.</li>
        <li>Las decisiones del Comité serán fundadas y de cumplimiento obligatorio.</li>
      </ul>

      <h4 className="rules-title">Artículo 29 – Interpretación del Reglamento</h4>
      <p>El Comité será la autoridad de interpretación del presente Reglamento.</p>
      <p>
        Ante cualquier situación no prevista expresamente, el Comité resolverá conforme al espíritu del Interclubes,
        sus principios institucionales y la equidad deportiva.
      </p>


      <h3 className="chapter-title">APÉNDICE 2026</h3>
      <h4 style={{ marginBottom: 8 }}>Reglamentación específica – Temporada 2026</h4>
      <p>
        El presente Apéndice complementa el Reglamento General de Interclubes y tendrá vigencia exclusiva para la
        temporada 2026, conforme lo acordado en la Reunión de Capitanes.
      </p>

      <h3 className="chapter-title">I. TORNEO APERTURA 2026</h3>

      <h4 className="rules-title">Art. 1 – Fechas</h4>
      <p>El Torneo Apertura 2026 comenzará el jueves 12 de marzo y finalizará el 2 de julio de 2026.</p>

      <h4 className="rules-title">Art. 2 – Modalidad Primera, Segunda y Tercera</h4>
      <ul>
        <li>8 equipos por categoría.</li>
        <li>Sistema: todos contra todos, ida y vuelta.</li>
        <li>Total: 14 fechas.</li>
        <li>El campeón asciende en forma directa.</li>
        <li>El último desciende en forma directa.</li>
      </ul>

      <p><b>Repechaje</b></p>
      <ul>
        <li>Lo disputarán el 7° de la categoría superior vs el 2° de la categoría inferior.</li>
        <li>Se jugará el 2 de julio.</li>
        <li>El equipo de la categoría superior tendrá ventaja deportiva y será local.</li>
      </ul>

      <h4 className="rules-title">Art. 3 – Modalidad Cuarta</h4>
      <ul>
        <li>10 equipos.</li>
        <li>Todos contra todos, una rueda (9 fechas).</li>
        <li>
          Finalizada la rueda:
          <ul>
            <li>Los 5 primeros disputarán Copa de Oro (una rueda, 5 fechas).</li>
            <li>Los 5 restantes disputarán Copa de Plata (una rueda, 5 fechas).</li>
          </ul>
        </li>
        <li>El campeón asciende directamente a Tercera.</li>
        <li>El subcampeón accede al repechaje por el ascenso a Tercera.</li>
      </ul>

      <h4 className="rules-title">Art. 4 – Reglas de Repechaje</h4>
      <p>Para participar del repechaje, cada jugador deberá:</p>
      <ul>
        <li>Haber disputado al menos 4 partidos en el equipo durante el Torneo.</li>
        <li>No haber disputado más partidos en una categoría superior que en la propia.</li>
      </ul>

      <h3 className="chapter-title">II. TORNEO CLAUSURA 2026</h3>

      <h4 className="rules-title">Art. 5 – Fechas</h4>
      <p><b>Primera, Segunda y Tercera:</b></p>
      <ul>
        <li>Inicio: jueves 13 de agosto.</li>
        <li>Finalización: 19 de noviembre.</li>
      </ul>
      <p><b>Cuarta:</b></p>
      <ul>
        <li>Inicio: jueves 6 de agosto.</li>
        <li>Finalización: 19 de noviembre.</li>
      </ul>

      <h4 className="rules-title">Art. 6 – Modalidad Primera, Segunda y Tercera</h4>
      <ul>
        <li>8 equipos por categoría.</li>
        <li>Todos contra todos, una rueda (7 fechas).</li>
      </ul>

      <p><b>Primera División</b></p>
      <ul>
        <li>Los equipos ubicados 1°, 2°, 3° y 4° disputarán un Súper 4.</li>
        <li>Modalidad: todos contra todos, ida y vuelta (6 fechas).</li>
        <li>El ganador será Campeón del Clausura de Primera.</li>
      </ul>

      <p><b>Reubicación de Primera</b></p>
      <ul>
        <li>Participan 5°, 6°, 7° y 8° de Primera, junto a 1°, 2°, 3° y 4° de Segunda.</li>
        <li>Todos contra todos, una rueda.</li>
        <li>Los 4 primeros permanecerán en Primera.</li>
        <li>Los ubicados 5°, 6°, 7° y 8° disputarán la temporada 2027 en Segunda.</li>
        <li>El mismo sistema se aplicará para la Reubicación de Segunda y Reubicación de Tercera.</li>
        <li>
          El campeón de Segunda y Tercera, serán el equipo que proviniendo de ésa categoría obtuviera la mejor
          posición final en la reubicación.
        </li>
      </ul>

      <h4 className="rules-title">Art. 7 – Modalidad Clausura Cuarta</h4>
      <ul>
        <li>10 equipos.</li>
        <li>Todos contra todos, una rueda.</li>
        <li>
          Finalizada la rueda:
          <ul>
            <li>1°, 2°, 3° y 4° jugarán Reubicación de Tercera junto con 5°, 6°, 7° y 8° de Tercera.</li>
            <li>De dicha reubicación se definirá quiénes competirán en Tercera y Cuarta en 2027.</li>
            <li>5° al 10° disputarán un Súper 6 de Cuarta (una rueda).</li>
          </ul>
        </li>
      </ul>

      <h3 className="chapter-title">III. DISPOSICIONES GENERALES 2026</h3>

      <h4 className="rules-title">Art. 8 – Fair Play</h4>
      <p>
        Se incorporará a fin de temporada el Premio Fair Play por Equipos, además del tradicional Fair Play por Jugador.
      </p>

      <h4 className="rules-title">Art. 9 – Listas de Buena Fe</h4>
      <ul>
        <li>La fecha límite para la presentación de las Listas de Buena Fe será el viernes 6 de marzo de 2026.</li>
        <li>Las mismas deberán enviarse al chat del Grupo de Capitanes correspondiente a cada categoría.</li>
      </ul>

      <h4 className="rules-title">Art. 10 – Comité Resolutivo</h4>
      <p>
        Con el objeto de dirimir cuestiones que no pudieran resolverse entre Capitanes, se constituye un Comité
        Resolutivo de cinco (5) miembros, el cual tendrá potestad para resolver cualquier cuestión vinculada al Torneo.
      </p>
      <p><b>Integrantes:</b></p>
      <ul>
        <li>Aldo Montefiore (BAC)</li>
        <li>Nicolás Jaca (Squash Club)</li>
        <li>Fernando Cano (CUBA)</li>
        <li>Ignacio Pavlovsky (Jockey)</li>
        <li>Mariano Guyot (Náutico San Isidro)</li>
      </ul>
    </div>
  );
};

export default Rules;
